import LocationSolution from '../models/LocationSolution'
import PermissionsService from '../services/PermissionsService'


export function userUriPermissionChecker() {

  function uriPermittedForLocation(locationId: number): boolean {

    // location must have URI and Reporting
    // user must have URI, Reporting, and Rate Management

    const locationSolution = LocationSolution.query().where('locationID', locationId).first()

    if (!locationSolution || (!locationSolution.uri || !locationSolution.reporting)) {
      return false
    }

    if (
      !PermissionsService.canLocationsUri(locationId) ||
      !PermissionsService.canReportingRead(locationId) ||
      !PermissionsService.canRateManagementWrite(locationId)
    ) {
      return false
    }

    return true

  }

  return {
    uriPermittedForLocation,
  }

}
